// Auto-generated from translation.csv; do not edit manually
export const koKR = {
  "accountGuide": {
    "content": "Touka의 아무 게임이나 열고, 게임 내 메인 화면에서 이메일을 연동하면 특별 할인 상품 혜택을 누릴 수 있습니다!",
    "title": "계정을 어떻게 생성하나요?"
  },
  "bottomNav": {
    "home": "홈",
    "myOrders": "내 주문"
  },
  "common": {
    "loading": "로딩 중...",
    "noData": "데이터 없음",
    "server": "서버"
  },
  "auth": {
    "tokenExpired": "로그인이 만료되었습니다"
  },
  "errors": {
    "900400": "내부 매개변수 오류",
    "900401": "로그인 인증에 실패했습니다",
    "900402": "로그인이 만료되었습니다",
    "1000000": "시스템 오류입니다. 나중에 다시 시도해 주세요",
    "1000001": "시스템 매개변수 오류입니다. 나중에 다시 시도해 주세요",
    "1000002": "캡차 ID 또는 코드를 입력해 주세요",
    "1000003": "이메일 형식이 올바르지 않습니다",
    "1000004": "캡차 코드가 올바르지 않습니다",
    "1000005": "인증 코드가 이미 전송되었습니다. 1분 후 다시 시도해 주세요",
    "1000006": "인증 코드 전송 한도에 도달했습니다. 내일 다시 시도해 주세요",
    "1000007": "이메일을 입력해 주세요",
    "1000008": "인증 코드를 입력해 주세요",
    "1000009": "인증 코드가 올바르지 않습니다",
    "1000010": "로그인 토큰을 가져오지 못했습니다",
    "1000011": "상품이 비활성 상태입니다. 다른 상품을 선택해 주세요",
    "1000012": "상품 구매 한도를 초과했습니다. 다른 상품을 선택해 주세요",
    "1000013": "상품 판매가 종료되었습니다",
    "1000014": "결제 수단이 활성화되어 있지 않습니다",
    "1000015": "이 계정은 상품 구매를 지원하지 않습니다. 고객센터에 문의해 주세요",
    "1000016": "주문 생성에 실패했습니다. 다시 시도해 주세요",
    "1000017": "주문을 취소할 수 없습니다",
    "1000018": "1회 구매 수량 한도에 도달했습니다",
    "1000019": "인증 코드가 만료되었습니다. 다시 요청해 주세요"
  },
  "footer": {
    "language": "중국어(간체)",
    "privacyPolicy": "개인정보 처리방침",
    "refundPolicy": "환불 정책",
    "termsOfService": "서비스 약관",
    "userSupport": "사용자 지원",
    "downloadNow": "지금 다운로드!"
  },
  "header": {
    "characterName": "캐릭터 이름",
    "gameServer": "게임 서버 그룹",
    "selectGameServer": "게임 지역 선택",
    "greeting": "안녕하세요",
    "loginPrompt": "로그인해 주세요",
    "switchServer": "전환",
    "title": "게임 충전 센터",
    "logout": "로그아웃"
  },
  "games": {
    "bamBamSquad": "BamBamSquad",
    "oopsieCroco": "앗차! 크로코"
  },
  "history": {
    "backToGameZone": "게임 스토어로 돌아가기",
    "allGames": "전체 게임",
    "empty": "주문 없음",
    "filter": {
      "all": "전체",
      "closed": "닫힘",
      "completed": "완료",
      "inProgress": "진행 중",
      "pendingDelivery": "배송 대기"
    },
    "orderTime": "주문 시간:",
    "pendingAutoCancelPrefix": "주문이",
    "pendingAutoCancelSuffix": "후 자동으로 취소됩니다",
    "cancelOrder": "주문 취소",
    "payOrder": "결제",
    "cancelOrderConfirmTitle": "주문을 취소할까요?",
    "cancelOrderConfirmPrimary": "취소 확인",
    "cancelOrderDismiss": "지금은 취소 안 함",
    "cancelOrderSuccess": "주문이 취소되었습니다",
    "previousPage": "이전 페이지",
    "nextPage": "다음 페이지",
    "status": {
      "cancelled": "닫힘",
      "completed": "거래 완료",
      "paid": "결제 완료",
      "pending": "결제 대기",
      "refunded": "환불됨",
      "shipped": "배송됨"
    }
  },
  "home": {
    "selectGame": "충전할 게임 선택",
    "selectGameMobileTitle": "충전 게임 선택",
    "mobileGameCardGo": "이동",
    "selectGameParts": {
      "prefix": "",
      "keyword": "충전",
      "suffix": "할 게임 선택"
    },
    "purchaseEntryParts": {
      "prefix": "",
      "keyword": "구매",
      "suffix": "하러 가기"
    },
    "noRoleAccount": "이 게임에 아직 캐릭터가 없습니다. 구매 전 게임에서 캐릭터를 먼저 생성해 주세요.",
    "noRoleRefreshPrefix": "이미 계정을 만드셨나요? 눌러서 ",
    "noRoleRefreshAction": "새로고침",
    "noRoleRefreshing": "새로고침 중…",
    "noRoleRefreshNotFound": "캐릭터 정보를 찾을 수 없습니다",
    "noRoleRefreshFailed": "새로고침에 실패했습니다. 잠시 후 다시 시도해 주세요."
  },
  "login": {
    "agreeTerms": {
      "and": "및",
      "prefix": "개인정보 처리방침 및 서비스 약관에 동의합니다",
      "privacy": "개인정보 처리방침",
      "terms": "서비스 약관"
    },
    "cancel": "취소",
    "bindGameGuide": "게임 연동 안내",
    "bindGameGuideContent": "Touka 게임을 실행한 뒤\n게임 내 설정에서\n이메일을 연동하면\n특가 상품을 이용할 수 있습니다!",
    "captchaPlaceholder": "인증 코드",
    "captchaRequired": "인증 코드를 입력해 주세요",
    "invalidCaptcha": "4자리 인증 코드를 입력하세요",
    "email": "이메일",
    "emailNotBound": "계정을 찾을 수 없습니다. 게임에 연동된 이메일을 입력해 주세요~",
    "emailPlaceholder": "이메일 주소를 입력해 주세요",
    "keepLogin": "15일 동안 로그인 상태 유지",
    "loading": "로그인 중...",
    "loginToStore": "Touka Store 로그인",
    "noAccount": "아직 계정이 없으신가요?",
    "password": "비밀번호",
    "passwordPlaceholder": "비밀번호를 입력해 주세요",
    "submit": "로그인",
    "title": "로그인",
    "invalidEmail": "유효한 이메일 주소를 입력해 주세요"
  },
  "logout": {
    "cancel": "취소",
    "confirm": "확인",
    "dontRemind": "다음부터 알림 안 함",
    "messageLine1": "로그아웃 후, 최근 30일 이내에 로그인한 모든 기기의",
    "messageLine2": "로그인 상태가 만료됩니다.",
    "title": "안내"
  },
  "menu": {
    "contactSupport": "고객 서비스 문의",
    "gameList": "게임 목록",
    "myOrders": "내 주문"
  },
  "paymentSuccess": {
    "account": "계정:",
    "celebrationTitle": "구매 성공",
    "confirm": "확인",
    "getPaymentInfoFailed": "결제 정보 가져오기 실패",
    "loading": "로딩 중...",
    "orderDate": "주문 날짜:",
    "orderId": "주문 번호:",
    "paymentMethod": "결제 방식:",
    "paypal": "PayPal",
    "price": "가격:",
    "purchaseContent": "구매 내용:",
    "quantity": "구매 수량:",
    "serverAndCharacter": "서버/캐릭터:",
    "title": "구매해 주셔서 감사합니다",
    "total": "총계:",
    "unionPay": "UnionPay",
    "amountPaid": "실제 결제 금액:",
    "closeModal": "닫기"
  },
  "productModal": {
    "confirm": "확인",
    "purchaseDetails": "구매 내역",
    "quantity": "수량:",
    "total": "총계:",
    "unitPrice": "단가:"
  },
  "redeemCode": {
    "title": "교환 코드",
    "close": "닫기",
    "gameIdLabel": "게임 ID:",
    "gameIdPlaceholder": "게임 ID를 입력하세요",
    "howToFindGameId": "게임 ID 찾는 방법",
    "giftCodeLabel": "교환 코드:",
    "giftCodePlaceholder": "교환 코드를 입력하세요",
    "captchaLabel": "인증 코드:",
    "captchaPlaceholder": "인증 코드를 입력하세요",
    "refreshCaptcha": "인증 코드 새로고침",
    "submit": "제출",
    "submitting": "제출 중...",
    "rule": "각 교환 코드는 계정당 한 번만 교환할 수 있습니다.",
    "success": {
      "title": "교환 성공",
      "description": "게임 내 우편함에서 보상을 받아 주세요!",
      "confirm": "확인"
    },
    "guide": {
      "stepOne": "1. 설정 페이지로 이동",
      "stepTwo": "2. 게임 ID 복사"
    },
    "messages": {
      "enterGiftCode": "먼저 교환 코드를 입력해 주세요",
      "requiredFields": "교환 정보를 모두 입력해 주세요",
      "captchaLoadFailed": "인증 코드를 불러오지 못했습니다. 눌러서 다시 시도하세요.",
      "success": "교환이 완료되었습니다. 보상이 게임 내 우편함으로 발송되었습니다.",
      "redeemFailed": "교환에 실패했습니다. 나중에 다시 시도해 주세요."
    },
    "resultMessages": {
      "0": "교환 성공! 보상이 게임 내 우편함으로 발송되었습니다. 꼭 확인해 주세요.",
      "1": "사용자 ID가 올바르지 않습니다. 확인 후 다시 시도해 주세요.",
      "2": "교환 코드가 올바르지 않습니다. 확인 후 다시 시도해 주세요.",
      "3": "교환 코드가 이미 사용되었습니다.",
      "4": "교환 코드가 만료되었습니다.",
      "5": "교환 코드가 올바르지 않습니다. 확인 후 다시 시도해 주세요.",
      "6": "교환 코드가 모두 소진되었습니다.",
      "7": "서버가 혼잡합니다. 나중에 다시 시도해 주세요.",
      "8": "요청 오류입니다. 나중에 다시 시도해 주세요.",
      "9": "확인 코드가 잘못되었거나 만료되었습니다. 확인 후 다시 시도해 주세요.",
      "10": "캐릭터가 속한 게임 서버를 찾을 수 없습니다. 캐릭터 정보를 확인한 후 다시 시도해 주세요. 현재 서버를 일시적으로 사용할 수 없습니다. 나중에 다시 시도해 주세요.",
      "11": "현재 서버를 일시적으로 사용할 수 없습니다. 나중에 다시 시도해 주세요.",
      "12": "수령 시간이 초과되었습니다. 나중에 다시 시도해 주세요.",
      "13": "수령에 실패했습니다. 나중에 다시 시도해 주세요."
    }
  },
  "products": {
    "giftPacks": "패키지",
    "diamond": "다이아",
    "products": "상품",
    "vouchers": "슈퍼 다이아몬드",
    "toukaCoin": "슈퍼 다이아몬드",
    "toukaCoinBonusTip": "TOUKA Store에서 10% 추가 획득!",
    "superValue": "초특가",
    "limitShort": "제한",
    "remainingShort": "남은 시간",
    "giftPackLimitType": {
      "lifetime": "평생 특가",
      "weekly": "주간 특가",
      "monthly": "월간 특가"
    },
    "howToUseVouchers": "슈퍼 다이아몬드 사용 방법",
    "voucherGuide": {
      "title": "슈퍼 다이아몬드 사용 방법",
      "step1": "1. 구매한 슈퍼 다이아몬드는 게임 내 우편함에서 확인해 주세요.",
      "step2": "2. 게임 내 상점 탭 상단에서 보유한 슈퍼 다이아몬드 잔액을 확인할 수 있습니다. 선물 패키지를 구매할 만큼 슈퍼 다이아몬드가 충분하면, 구매 시 슈퍼 다이아몬드가 우선 사용됩니다.",
      "backToProducts": "상품 목록으로 돌아가기"
    },
    "luxuryVouchers": "슈퍼 다이아몬드"
  },
  "purchaseConfirm": {
    "card": "신용카드/직불카드",
    "confirm": "확인",
    "dontAskAgain": "30일 내 다시 묻지 않기",
    "gameServer": "게임 서버",
    "paymentMethods": "지원하는 결제 수단",
    "paypal": "PayPal",
    "title": "이 계정으로 구매하시겠습니까",
    "unionPay": "은련 카드"
  },
  "serverSelect": {
    "characterLabel": "캐릭터 이름",
    "characterPlaceholder": "캐릭터를 선택하세요",
    "confirm": "확인",
    "noResults": "결과 없음",
    "serverPlaceholder": "서버 이름을 입력하여 검색하세요",
    "title": "게임 서버 선택"
  },
 "orientation": {
   "bestExperience": "최상의 이용 경험을 위해 세로 화면으로 전환해 주세요"
 },
  "pendingOrder": {
    "title": "알림",
    "message": "진행 중인 주문이 있습니다. 확인하시겠습니까?",
    "goToOrders": "주문 보기",
    "cancel": "취소"
  },
 "support": {
    "cancel": "취소",
    "copied": "복사 완료",
    "copy": "한 번에 복사",
    "description": "자세한 정보는 공식 지원 이메일로 보내 주세요.",
    "title": "고객 지원"
  },
  "verification": {
    "back": "뒤로 가기",
    "enterCode": "계속하려면 인증 코드를 입력하세요",
    "incorrectCode": "인증 코드가 올바르지 않습니다",
    "invalidCode": "6자리 인증 코드를 입력하세요",
    "noCode": "인증 코드를 못 받으셨나요?",
    "sentTo": "인증 코드가 다음 주소로 발송되었습니다",
    "submit": "제출",
    "submitting": "제출 중..."
  }
} as const;
